import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RuleConfigViewComponent } from '../rule-config-view/rule-config-view.component';
import type { RulePackageVersion, PreviewResult } from 'src/app/core/services/rules-api.service';

@Component({
  selector: 'app-version-detail-modal',
  standalone: true,
  imports: [CommonModule, RuleConfigViewComponent],
  templateUrl: './version-detail-modal.component.html',
})
export class VersionDetailModalComponent {
  @Input() open = false;
  @Input() version: RulePackageVersion | null = null;
  @Input() lockedKeys: string[] = [];
  @Input() preview: PreviewResult | null = null;
  @Input() validating = false;

  @Output() close = new EventEmitter<void>();
  @Output() validate = new EventEmitter<RulePackageVersion>();
}
